<template>
   <div>
      <div class="text-center" style="margin:20px 0 ">
         <b-button
            size="is-medium"
            type="is-light"
            icon-left="arrow-left"
            @click="$emit('reset')"
         >Retour</b-button>
      </div>
      <div class="spinner-container" v-if="loading">
         <BeatLoader color="#1389EF" />
      </div>

      <div v-else>
         <!-- AUCUN ABONNEMENT (inclus abo annulé et à expiration) -->
         <div
            v-if="user.abonnement == null || (user.abonnement && user.abonnement.stripe_status == 'canceled')"
            style="max-width:700px;margin:auto;padding-top:30px"
         >
            <div class="sous-titre">S'abonner à premium</div>

            <div class="container-mobile">
               <form id="payment-form">
                  <b-field label="Nom sur la carte">
                     <b-input required id="card-holder-name" v-model="cardHolderName"></b-input>
                  </b-field>
                  <b-field label="Adresse de facturation">
                     <b-input required v-model="adresse"></b-input>
                  </b-field>
                  <b-field label="Code Postal">
                     <b-input required v-model="code_postal"></b-input>
                  </b-field>
                  <b-field label="Ville">
                     <b-input required v-model="ville"></b-input>
                  </b-field>

                  <!-- Card -->
                  <b-field label="Carte">
                     <div id="card-element"></div>
                  </b-field>

                  <a @click="showCodePromo = !showCodePromo">Un code promo ?</a>
                  <b-field
                     label="Code promo"
                     v-show="showCodePromo"
                     label-position="on-border"
                     style="margin-top:30px;"
                     :type="type"
                  >
                     <b-input v-model="code_promo"></b-input>
                  </b-field>

                  <div class="container-mobile">
                     <b-button
                        style="margin-bottom:25px; margin-top:20px"
                        native-type="submit"
                        type="is-primary"
                        id="card-button"
                        :loading="loading_form"
                     >Payer {{ prix }} € / an</b-button>
                  </div>
               </form>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
   import axios from "axios";
   import { BeatLoader } from "@saeris/vue-spinners";
   export default {
      components: { BeatLoader },

      data() {
         return {
            loading: false,
            intent: null,
            loading_form: false,
            cardHolderName: "",
            code_promo: "",
            adresse: "",
            code_postal: "",
            ville: "",
            showCodePromo: false,
            codes_promo: ["LANCEMENT", "SIMAPI"]
         };
      },
      async mounted() {
         if (
            this.user.abonnement == null ||
            this.user.abonnement.stripe_status == "canceled"
         ) {
            this.loading_form = true;
            axios.defaults.headers.common["Authorization"] =
               "Bearer " + this.$store.state.token;
            let res = await axios.get("abonnement/intent");
            this.loading_form = false;
            this.intent = res.data.intent;
            let stripe_key = res.data.stripe_pk;

            const stripe = window.Stripe(stripe_key);
            const elements = stripe.elements();
            const cardElement = elements.create("card");

            cardElement.mount("#card-element");

            const cardButton = document.getElementById("card-button");

            cardButton.addEventListener("click", async e => {
               e.preventDefault();
               this.loading_form = true;
               const { setupIntent, error } = await stripe.handleCardSetup(
                  this.intent.client_secret,
                  cardElement,
                  {
                     payment_method_data: {
                        billing_details: { name: this.cardHolderName }
                     }
                  }
               );

               if (error) {
                  this.$buefy.toast.open({
                     message: error.message,
                     type: "is-danger"
                  });
               } else {
                  axios
                     .post("/abonnement/premium", {
                        stripeToken: setupIntent.payment_method,
                        code_promo: this.type,
                        adresse: this.adresse,
                        code_postal: this.code_postal,
                        ville: this.ville
                     })
                     .then(async () => {
                        this.loading_form = false;
                        this.$buefy.toast.open({
                           message: "Vous êtes désormais abonné !",
                           type: "is-success"
                        });
                        this.$router.push({ name: "dashboard" });
                     });
               }
            });
         }
      },
      computed: {
         user() {
            return this.$store.state.user;
         },
         type() {
            if (this.codes_promo.includes(this.code_promo.toUpperCase())) {
               return "is-success";
            }
            return "";
         },
         prix() {
            if (this.type == "is-success") {
               return 36 * 0.8;
            }
            return 36;
         }
      }
   };
</script>

<style>
</style>
